import {
    YCol, YInput, YRecaptcha, YRow, YTextarea, YUploader,
} from '@components/index';
import CoreMixin from '@nodes/mixins/Core';
import { YSectionTitle } from '@rogues/index';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import { Component, Mixins } from 'vue-property-decorator';
import Props from './props';

interface RecaptchaRef extends Vue {
    reset(): void;
    verify(): void;
}

@Component({
    components: {
        YSectionTitle,
        YInput,
        YTextarea,
        YRecaptcha,
        YCol,
        YRow,
        YUploader,
    },
})

/**
 * @name CommentsForm
 */
export default class CommentsForm extends Mixins(HybridMixin, Props, CoreMixin) {
    model: { [k: string]: any } = {};
    $refs!: {
        recaptcha: RecaptchaRef;
    };

    /**
     * Verify recaptcha
     * Check recaptcha is active
     */
    beforeSubmit() {
        this.$wait.start('saving-comment');
        if (this.getValue('configs')?.recaptcha?.active === '1') {
            this.$refs.recaptcha.verify();
        } else {
            this.save();
        }
    }

    /**
     * Set token and start Sending Comment
     *
     * @param {string} token
     */
    afterVerify(token: string) {
        this.model['g-recaptcha-response'] = token;
        this.save();
    }

    /**
     * Do send comment
     *
     * @returns {object}
     */
    save() {
        const params: { [key: string]: any } = {
            ...this.model,
        };

        if (this.urlEncode) {
            params.slug = this.urlEncode;
            params.type = this.postType;
        } else if (this.postId) {
            params.id = this.postId;
        }

        return this.$services.Commenting.commentSave(params)
            .then(() => {
                this.model = {};
                this.$toast.success(this.$t('comments.message.success'));
                this.$wait.start('comment-form-reload');
                this.$emit('refresh');
            })
            .catch((error) => {
                this.handleError(error);
            })
            .finally(() => {
                this.$wait.end('saving-comment');
                this.$wait.end('comment-form-reload');
                this.$refs.recaptcha.reset();
            });
    }
}
